import './LanguageSwitcher.scss';

const LanguageSwitcher = ({ onClick, title, currentLocale }) => {
    return (
        <button className={"language-switcher language-switcher--current-" + currentLocale} type="button" onClick={onClick}>{title}</button>
    );
};

export default LanguageSwitcher;